import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import './index.css'
import App from './App.tsx'
import { AuthProvider } from '@/auth/AuthProvider'
import { Toaster } from '@/components/ui/sonner'
import { installErrorReporter } from '@/lib/errorReporter'

// Install before React mounts so even a throw during the first render — or any
// async error that escapes the React error boundaries — surfaces the actual
// error instead of unmounting the SPA into the blank orange background.
installErrorReporter()

// After a deploy the old chunk names are gone: reload once to pick up the new build. The
// timestamp guard stops a reload loop; blocked storage means no reload (error boundary shows).
window.addEventListener('vite:preloadError', (event) => {
  try {
    const last = Number(sessionStorage.getItem('vonk-chunk-reload') ?? 0)
    if (Date.now() - last < 60_000) return
    sessionStorage.setItem('vonk-chunk-reload', String(Date.now()))
    event.preventDefault()
    window.location.reload()
  } catch (error) {
    // Storage unavailable: do not reload, let the error boundary report the failure.
    console.warn('vite:preloadError: no reload, storage unavailable', error)
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
